export default {
  // 跨鏈詳情彈框
  dialog: {
    title: "查看詳情",
    sourceSection: {
      hashLabel: "來源交易哈希",
      timeLabel: "發起時間:",
    },
    targetSection: {
      hashLabel: "目標交易哈希",
      timeLabel: "接收時間:",
    },
    sender: "發送方",
    receiver: "接收方",
    flowText: "跨鏈換幣",
    copySuccess: "複製成功",
  },

  // 跨鏈列表
  list: {
    sort: {
      sendAmount: "發送數量",
      sendTime: "發送時間",
      receiveAmount: "接收數量",
      receiveTime: "接收時間",
      desc: "倒序",
      asc: "正序",
    },
    hash: {
      source: "來源哈希：",
      target: "目標哈希：",
    },
    grid: {
      sender: "發送方",
      receiver: "接收方",
      sendAmount: "發送數量",
      sendTime: "發送時間",
      receiveAmount: "接收數量",
      receiveTime: "接收時間",
    },
    buttons: {
      trace: "跨鏈追蹤",
      detail: "詳情",
    },
    messages: {
      traceSuccess: "跨鏈追蹤成功",
      traceFailed: "跨鏈追蹤失敗，請稍後重試",
      chainNotSupportedWithName:
        "當前跨鏈追蹤至{chainName}鏈，當前畫布暫不支持上圖分析，是否去跨鏈瀏覽器查看數據？",
      chainNotSupportedGeneric:
        "當前跨鏈追蹤至的鏈暫不支持上圖分析，是否去跨鏈瀏覽器查看數據？",
      tip: "提示",
      cancel: "取消",
      viewInBrowser: "瀏覽器查看",
    },
    download: {
      filename: "跨鏈交易詳情.xlsx",
    },
  },
};
